var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-form',{attrs:{"mode":"add","source-id":_vm.$route.query.sourceId || ''}})
}
var staticRenderFns = []

export { render, staticRenderFns }